import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

// andRoles OR orRoles is set
const isArrayOfString = a => !!(Array.isArray(a) && a.length && a.filter(s => _.isString(s)).length === a.length);
const validPropTypesRoles = (andRoles, orRoles) => isArrayOfString(andRoles) !== isArrayOfString(orRoles) ?
		null : new Error('Must have andRoles or orRoles but not both');

const propTypes = {
	// must have all these roles (can't use both orRoles and andRoles but must use at least one of them)
	andRoles: props => validPropTypesRoles(props.andRoles, props.orRoles),

	// must have at least one of these roles (can't use both orRoles and andRoles but must use at least one of them)
	orRoles: props => validPropTypesRoles(props.andRoles, props.orRoles),

	// string array of roles the user currently has
	userRoles: PropTypes.arrayOf(PropTypes.string).isRequired,

	// function for rendering content of the secured content if security passes
	renderSecuredContent: PropTypes.func.isRequired,

	// function for rendering content of hte secured content if security fails
	renderNotAllowedContent: PropTypes.func,
};

const defaultProps = {
	andRoles: undefined,
	orRoles: undefined,
	renderNotAllowedContent: undefined,
};

export default class SecureContent extends React.Component {
	render() {
		return (
			(!_.isEmpty(this.props.andRoles) && _.intersection(this.props.andRoles, this.props.userRoles).length === this.props.andRoles.length) ||
				(!_.isEmpty(this.props.orRoles) && this.props.userRoles.filter(role => this.props.orRoles.includes(role)).length)
		) ? this.props.renderSecuredContent() : (this.props.renderNotAllowedContent && this.props.renderNotAllowedContent()) || null;
	}
}

SecureContent.defaultProps = defaultProps;
SecureContent.propTypes = propTypes;
